import { call, put, takeLatest } from 'redux-saga/effects';

import supplierSettingsService from 'services/supplierSettingsService';

import { supplierFacilitiesFetch, types } from './actions';

export default function* root() {
  yield takeLatest(
    types.SUPPLIER_FACILITIES_FETCH_REQUEST,
    watchSupplierFacilitiesFetch,
  );
}

export function* watchSupplierFacilitiesFetch() {
  try {
    const supplierFacilities = yield call(
      supplierSettingsService.supplierFacilities.list,
    );
    yield put(supplierFacilitiesFetch.success({ supplierFacilities }));
  } catch (error) {
    yield put(supplierFacilitiesFetch.error(error));
  }
}

export function* initSaga() {
  yield call(watchSupplierFacilitiesFetch);
}
